/**
 * Determines ability to route enter.
 *
 * @param      {<type>}   permission      The permission
 * @param      {string}   [redirect='/']  The redirect
 * @return     {boolean}  True if able to route enter, False otherwise.
 */
const canRouteEnter = (permission, redirect = '/') => (to, from, next) => {
  next(ctx => {
    if (!ctx.$can(permission)) ctx.$router.push(redirect)
  })
}

//
export { canRouteEnter }